import globalAxios from "../../../util/Api";
import { GET_THEMES, DELETE_THEME, CREATE_THEME, EDIT_THEME, START_LOADING, STOP_LOADING, ERROR } from "./types";
import { LogoutAction } from "../../../actions";

export const GetThemes = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/themes`)
      .then(res => {
        const newres = res.data.data.map(obj => {
          obj['name'] = obj['theme']
          delete obj['theme']
          return obj
        })
        if (newres) {
          dispatch({ type: GET_THEMES, payload: newres })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const CreateThemeAction = (branchName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('theme[theme]', branchName);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/themes`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['theme']
        delete newres['theme']
        if (newres) {
          dispatch({ type: CREATE_THEME, payload: newres })
          dispatch(GetThemes())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const EditTheme = (id, themeName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('theme[theme]', themeName);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/themes/${id}`, bodyFormData)
      .then(res => {
        const newres = res.data.data
        newres['name'] = newres['theme']
        delete newres['theme']
        if (newres) {
          dispatch({ type: EDIT_THEME, payload: newres })
          dispatch(GetThemes())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
export const DeleteTheme = (id) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/themes/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_THEME })
          dispatch(GetThemes())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
